<template>
  <div>
    <installment-product-view
      v-if="(status === 0 || status === 3) && !isPrint"
      :item="getItem"
      :isEdit="isEdit"
      @ConvertPdfEvent="convertPdfEvent"
    ></installment-product-view>
    <installment-product-print
      v-else-if="isPrint && (status === 0 || status === 3)"
      :item="getItem"
      @PrintTemplateEvent="printTemplateEvent"
    ></installment-product-print>
    <credit-product-view
      v-else-if="status === 1 && !isPrint"
      :item="getItem"
      @ConvertPdfEvent="convertPdfEvent"
    ></credit-product-view>

    <!--和潤-->
    <!--        <loanhfc-edit-view v-else-if="status === 4 && !isPrint && isEdit === true" :item="getItem"></loanhfc-edit-view>-->
    <!-- <loanhfc-view
      v-else-if="status === 4 && !isPrint && version === 0"
      :item="getItem"
      @ConvertPdfEvent="convertPdfEvent"
    ></loanhfc-view> -->
    <loanhfc-v-202105-view
    v-else-if="status === 4 && !isPrint && version === 0"
      :item="getItem"
      @ConvertPdfEvent="convertPdfEvent">
    </loanhfc-v-202105-view>
    <loanhfc-template-view
      v-else-if="status === 4 && isPrint && version === 0"
      :item="getItem"
      @PrintTemplateEvent="printTemplateEvent"
    ></loanhfc-template-view>
    <loanhfc-view-print-v1
      v-else-if="status === 4 && version === 1"
      :item="getItem"
    ></loanhfc-view-print-v1>
    <loanhfc-view-print-v2
      v-else-if="status === 4 && version === 2"
      :item="getItem"
    ></loanhfc-view-print-v2>
    <!--CA-->
    <edit-c-a-template-view
      v-else-if="status === 2 && !isPrint"
      :item="getItem"
    ></edit-c-a-template-view>
    <edit-c-a-product-print
      v-else-if="status === 2 && isPrint"
      :item="getItem"
      :platform="platform"
      @ConvertPdfEvent="convertPdfEvent"
    ></edit-c-a-product-print>
    <!--創鉅-->
    <entrepreneur-print
      v-else-if="status === 5 && !isPrint"
      :item="getItem"
    ></entrepreneur-print>
    <entrepreneur-template-view
      v-else-if="status === 5 && isPrint"
      :item="getItem"
    ></entrepreneur-template-view>
    <!--合迪-->
    <finatrade-print
      v-else-if="status === 6 && !isPrint"
      :item="getItem"
    ></finatrade-print>
    <finatrade-template-view
      v-else-if="status === 6 && isPrint"
      :item="getItem"
    ></finatrade-template-view>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import InstallmentProductView from "./InstallmentProductView";
import InstallmentProductPrint from "./InstallmentProductPrint";
import CreditProductView from "./CreditProductView";
import LoanhfcView from "./loanhfcView";
import LoanhfcV202105View from "./LoanhfcV202105View";
import loanhfcEditView from "./loanhfcEditView";
import loanhfcTemplateView from "./loanhfcTemplateView";
import EditCATemplateView from "./EditCATemplateView";
import EditCAProductPrint from "./EditCAProductPrint";
import LaonhfcModel from "../../models/LaonhfcModel";
import PaymentInfoModel from "../../models/PaymentInfoModel";
import CaseInsureModel from "../../models/CaseInsureModel";
import EntrepreneurPrint from "./EntrepreneurPrint";
import EntrepreneurTemplateView from "./EntrepreneurTemplateView";
import FinatradePrint from "./FinatradePrint";
import FinatradeTemplateView from "./FinatradeTemplateView";
import loanhfcViewPrintV1 from "./loanhfcViewPrintV1";
import loanhfcViewPrintV2 from "./loanhfcViewPrintV2";
import download from "downloadjs";
import * as htmlToImage from "html-to-image";
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";
import AttachmentModel from "../../models/AttachmentModel";
import printJS from 'print-js'
import { exportPdf } from "../utils/tool";

export default {
  name: "CreditProductPrint",
  components: {
    CreditProductView,
    InstallmentProductView,
    InstallmentProductPrint,
    LoanhfcView,
    LoanhfcV202105View,
    loanhfcEditView,
    loanhfcTemplateView,
    EditCATemplateView,
    EditCAProductPrint,
    EntrepreneurPrint,
    EntrepreneurTemplateView,
    FinatradePrint,
    FinatradeTemplateView,
    loanhfcViewPrintV1,
    loanhfcViewPrintV2
  },
  data() {
    return {
      item: null,
      status: 0,
      isPrint: false,
      isEdit:false,
      version: 0,
      platform: 0
    };
  },
  created() {
    const caseId = this.$route.query.caseId;
    this.status = parseInt(this.$route.query.caseCategory, 10);
    this.isPrint = this.$route.query.isPrint === "true";
    this.isEdit = this.$route.query.isEdit === "true";
    this.platform = parseInt(this.$route.query.platform);

    if (this.$route.query.caseVersion) {
      this.version = parseInt(this.$route.query.caseVersion, 10);
    }
    if (caseId) {
      if (this.status === 2) {
        if(this.platform === 0) {
          this.fetchCreditProductInfo({caseId}).then((results) => {
            if (Object.keys(results).length) {
              this.item = results[0];
              this.sortItemInfo();
            }
          });
        } else {
          this.caInfo({ caseId }).then((results) => {
            if (Object.keys(results).length) {
              this.item = results.data.data;
              this.sortItemInfo();
            }
          });
        }
      } else {
        this.fetchFinanceCreditInfo({ caseId }).then((results) => {
          if (results.length) {
            this.item = results[0];
            this.sortItemInfo();
          }
        });
      }
    }
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    getItem() {
      return this.item;
    },
    relationshipList() {
      return [
        { key: 1, name: "配偶" },
        { key: 2, name: "父母" },
        { key: 3, name: "兄弟姐妹" },
        { key: 4, name: "其他親友" },
        { key: 5, name: "同事" },
        { key: 6, name: "朋友" },
        { key: 7, name: "子女" },
        { key: 8, name: "其他" },
      ];
    },
    cityList() {
      return [
        { key: "10001", name: "北縣" },
        { key: "10002", name: "宜縣" },
        { key: "10003", name: "桃縣" },
        { key: "10004", name: "竹縣" },
        { key: "10005", name: "苗縣" },
        { key: "10006", name: "中縣" },
        { key: "10007", name: "彰縣" },
        { key: "10008", name: "投縣" },
        { key: "10009", name: "雲縣" },
        { key: "10010", name: "嘉縣" },
        { key: "10011", name: "南縣" },
        { key: "10012", name: "高縣" },
        { key: "10013", name: "屏縣" },
        { key: "10014", name: "東縣" },
        { key: "10015", name: "花縣" },
        { key: "10016", name: "澎縣" },
        { key: "10017", name: "基市" },
        { key: "10018", name: "竹市" },
        { key: "10020", name: "嘉市" },
        { key: "09007", name: "連江" },
        { key: "09020", name: "金門" },
        { key: "63000", name: "北市" },
        { key: "64000", name: "高市" },
        { key: "65000", name: "新北市" },
        { key: "66000", name: "中市" },
        { key: "67000", name: "南市" },
        { key: "68000", name: "桃市" },
      ];
    },
  },
  methods: {
    ...mapActions(["fetchFinanceCreditInfo", "caInfo", "fetchCreditProductInfo"]),
    sortItemInfo() {
      if (!this.item.laonhfcInfo) {
        this.item.laonhfcInfo = new LaonhfcModel();
      }
      if (!this.item.paymentInfo) {
        this.item.paymentInfo = new PaymentInfoModel();
      }
      if (!this.item.caseInsure) {
        this.item.caseInsure = new CaseInsureModel();
      }

      // console.log(`info == ${JSON.stringify(this.item)}`);
      const findPlace = this.cityList.find(c=>c.key === this.item.useCase.guarantor_issue_place);
      if (findPlace){
        this.item.jointGuarantor.memberIdCity = findPlace.name;
      }
      const findRelationship = this.relationshipList.find(c=>c.key === this.item.jointGuarantor.relationship);
      if (findRelationship){
        this.item.jointGuarantor.type = findRelationship.name;
      }
    },
    printTemplateEvent(nodeList) {
      let valueArray = [];

      Promise.all(
        nodeList.map((element) =>
           htmlToImage.toPng(element).then(function (dataUrl) {
            let attachmentItem = new AttachmentModel();
            const caseID = Math.uuidFast();
            valueArray.push(dataUrl)
          })
        )).then(() => printJS({printable: valueArray, type: 'image'})
      )
    },
    convertPdfEvent(nodeList) {
      let valueArray = [];
      Promise.all(
        nodeList.map((element) =>
           htmlToImage.toPng(element).then(function (dataUrl) {
            let attachmentItem = new AttachmentModel();
            const caseID = Math.uuidFast();
            attachmentItem.caseId = caseID;
            attachmentItem.file_index = 0;
            attachmentItem.file_body_encode = dataUrl;
            attachmentItem.file_size = dataUrl.length;
            attachmentItem.content_type = "png";
            attachmentItem.name = caseID;
            valueArray.push(attachmentItem)
          })
      )).then(() => this.convertPDF(valueArray))
    },
    async convertPDF(list) {
      const pdfFile = await exportPdf(list);
      const name = Math.uuidFast();
      const fileName = `${name}.pdf`;
      download(pdfFile, fileName, "application/pdf");
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/web/CreditProductPrint.vue